import axios from 'axios';
import store from '@/store';
import { router } from '@/main';

class BaseApiRepository {
    constructor() {
        this.baseURL = process.env.VUE_APP_API_URL;
    }

    getAuthHeader(token) {
        const devMode = store.state.user.devMode;
        return devMode ? { 'X-API-KEY': `${token}` } : { Authorization: `Bearer ${token}` };
    }

    async apiRequest(method, url, data = null, params = {}) {
        if (store.getters['user/isInvalidLoggedInAccount']) {
            console.error('Account ID is not set or user is disabled');
            store.dispatch('user/logout');
            if (router.currentRoute.value.path !== '/') {
                router.push({ name: 'Login', query: { logout: 'true' } });
            }
            return;
        }
        try {
            return store.dispatch('user/apiCall', async (token) => {
                const headers = {
                    ...this.getAuthHeader(token),
                };

                // Set content-type for requests with data
                if (data && method.toLowerCase() !== 'get') {
                    headers['Content-Type'] = 'application/json';
                }

                const config = {
                    method,
                    url: `${this.baseURL}/accounts/${store.state.user.user.account_id}/${url}`,
                    headers,
                    params: { ...params },
                    data,
                };

                return await axios(config);
            });
        } catch (error) {
            throw error;
        }
    }
}

export default BaseApiRepository;
